const KEY = 'EVENT-ADDITIONAL';

export { KEY };
